import script from "./CreatorAcademy.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorAcademy.vue?vue&type=script&setup=true&lang=js"

import "./CreatorAcademy.vue?vue&type=style&index=0&id=cdc7a68c&lang=scss"
import "./CreatorAcademy.vue?vue&type=style&index=1&id=cdc7a68c&lang=css"

const __exports__ = script;

export default __exports__